
import state from './moduleCommunityMembersState.js';
import mutations from './moduleCommunityMembersMutations.js';
import actions from './moduleCommunityMembersActions.js';
import getters from './moduleCommunityMembersGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
